module.exports = __webpack_public_path__ + "img/itx-file-type-wmv.a81c7ea4.svg";